export const RadarViews = {
  ALL: 'View_All',
  LIVE: 'View_Live',
  TEST: 'View_Test',
}
